import BaseController from "../sharedControllers/BaseController";
import { Routes } from "akademika/akamont/constants/Routes";

/**
 * @namespace akademika.akamont.pages.measurementUnitList
 */
export default class MeasurementUnitList extends BaseController {
  route = Routes.MEASUREMENT_UNIT_LIST;
  parentRoute = Routes.DASHBOARD;

  public async onRouteMatched() {
    await this.fetchModel("api/MeasurementUnit/GetList");
  }

  public async onMeasurementUnitDetails(id: string) {
    this.navTo(Routes.MEASUREMENT_UNIT_DETAILS, { measurementUnitId: id });
  }
}
